import classNames from 'classnames';
import { Tumbler, TumblerProps } from 'lego-on-react';
import { ControlProps } from 'lego-on-react';
import { TumblerTone } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Omit } from '../../typings/utils';

import './TumblerDecorator.css';

const BLOCK = 'tumbler-decorator';

export enum AdditionalTumblerTone {
    direct = 'direct'
}

export type TumblerDecoratorProps = Omit<TumblerProps, 'tone' | 'cls'> & {
    tone?: TumblerTone | AdditionalTumblerTone;
    cls?: string;
};

export class TumblerDecorator extends React.PureComponent<TumblerDecoratorProps & ControlProps> {
    render() {
        const { cls, tone, ...otherProps } = this.props;

        if (tone && tone === AdditionalTumblerTone.direct) {
            return (
                <Tumbler
                    cls={classNames(
                        cls,
                        Bem.cls({
                            block: BLOCK,
                            mods: {
                                tone
                            }
                        })
                    )}
                    {...otherProps}
                >
                    {this.props.children}
                </Tumbler>
            );
        }

        return (
            <Tumbler cls={cls} tone={tone} {...otherProps}>
                {this.props.children}
            </Tumbler>
        );
    }
}
